import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { localDataService } from '../../Services/localDataServices';
import { environment } from '../../../environments/environment';

declare var $: any;  //定义jquery
@Component({
  selector: 'historyList',
  providers: [localDataService],
  templateUrl: './historyList.component.html',
  styleUrls: ['./historyList.component.css']
})
export class historyListComponent {
  status: any;
  items: any = [];
  beiannum = 3
  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _localDataService: localDataService,
    //  private _codeflagService: codeflagService,
    private _location: Location
  ) {

  }

  singleLength: any = 0;
  last_page: any = 0;
  ngOnInit() {
    //域名备案
    if (window.location.host.indexOf('autoport.com.cn') > -1) {
      this.beiannum = 3
    } else if (window.location.host.indexOf('baoguan001.com') > -1) {
      this.beiannum = 1
    } else if (window.location.host.indexOf('codeflagai.com') > -1) {
      this.beiannum = 2
    }
    this.getList('', 1, 10)
  }

  show(orderNo) {
    console.log(environment.detailsToPath)
    window.open(`${environment.detailsToPath}/identifyDetails/${orderNo}/${sessionStorage.getItem("token")}`)

    // this._router.navigate(['imgUpdata', orderNo]);
  }
  showShoppingOrder(orderNo) {
    this._router.navigate(['shoppingOrder', orderNo]);
  }
  showContainerNumber(orderNo) {
    this._router.navigate(['containerNumber', orderNo]);
  }
  showsealNumber(orderNo) {
    this._router.navigate(['sealNumber', orderNo]);
  }
  showByOrderNo(orderNo) {
    this._router.navigate(['customsDeclarations', orderNo]);
    // window.open(`http://details.` + document.domain.substring(document.domain.indexOf(".") + 1) + `/shanghaiEDI/` + orderNo + `?Custoken=` + sessionStorage.getItem("token") + `&User=`);
  }

  TD: any = [];
  JZX: any = [];
  XFH: any = [];
  getList(orderOutNo, pageNum, pageSize) {
    if (this._i == 0) {
      this._localDataService.haiyunList(pageNum, pageSize)
        .then(data => {
          this.status = data;
          if (this.status.status) {
            this.items = this.status.data
            this.singleLength = this.status.total;
            this.last_page = Math.ceil(this.status.total / 10);
          } else {
            //alert(this.status.message)
          }

        }).catch(err => { console.log(err); });
    } else if (this._i == 1) {
      this._localDataService.tuoshuList(orderOutNo, pageNum, pageSize, '', '')
        .then(data => {
          this.status = data;
          if (this.status.status) {
            this.items = this.status.data
            this.singleLength = this.status.total;
            this.last_page = Math.ceil(this.status.total / 10);
          } else {
            //alert(this.status.message)
          }

        }).catch(err => { console.log(err); });
    } else if (this._i == 2) {
      //托单
      this._localDataService.apiCommon('/Y0005/list', { pageIndex: pageNum, pageSize: pageSize })
        .then(data => {
          this.status = data;
          if (this.status.status) {
            this.TD = this.status.data
            this.singleLength = this.status.total;
            this.last_page = Math.ceil(this.status.total / 10);
          } else {
            //alert(this.status.msg)
          }
        }).catch(err => { console.log(err); });
    } else if (this._i == 3) {
      //集装箱
      this._localDataService.apiCommon('/Y0001/list', { pageIndex: pageNum, pageSize: pageSize })
        .then(data => {
          this.status = data;
          if (this.status.status) {
            this.JZX = this.status.data
            console.log(this.JZX)
            this.singleLength = this.status.total;
            this.last_page = Math.ceil(this.status.total / 10);
          } else {

          }
        }).catch(err => { console.log(err); });
    } else if (this._i == 4) {
      //箱封号
      this._localDataService.apiCommon('/S0002/list', { pageIndex: pageNum, pageSize: pageSize })
        .then(data => {
          this.status = data;
          if (this.status.status) {
            this.XFH = this.status.data
            this.singleLength = this.status.total;
            this.last_page = Math.ceil(this.status.total / 10);
          } else {

          }
        }).catch(err => { console.log(err); });
    }
  }

  //分页
  p: number = 1;
  next() {
    if (this.p == this.last_page || this.last_page == 0) {
      return false;
    }
    this.p = this.p + 1;
    this.getList('', this.p, 10);
  }
  before() {
    if (this.p == 1) {
      return false;
    }
    this.p = this.p - 1;
    this.getList('', this.p, 10);
  }

  _i: number = 0;
  tab(i) {
    this._i = i;
    $(".account_history_li").removeClass("active").eq(i).addClass("active")
    $(".history-main").addClass("hide").eq(i).removeClass("hide")
    this.singleLength = 0;
    this.last_page = 0
    this.getList('', 1, 10);
  }



}



// WEBPACK FOOTER //
// /srv/jenkins-test/workspace/dev-doc-web/src/app/component/historyList/historyList.component.ts